<template>
  <div class="business-container">
    <top-nav :shrinked="true"/>
<!--    <img class="banner" src="">-->
<!--    <div class="site-text-content bg-gray">-->
<!--      嘉宏商业围绕“3+1”产品线布局规划，全面运营星光天地、星光城、星光里和灯贸中心。以运营管理嘉宏集团持有型商业资产为主营业务，以新潮商业为目标蓄势成长，与“城市力”共澎湃，“星光”系列已在常州布局5个商业项目，总商业体量近100万方，形成嘉宏在常州“多域共振”的商业地产新格局。-->
<!--    </div>-->
<!--    <div class="VehicleSlider_vehicleSliderWrapper__GnfuV">-->
<!--      <div class="VehicleSlider_vehicleSliderInnerWrapper__UOqKE" style="opacity: 1">-->
<!--        <div class="Carousel_carousel__rSN5L carousel" id="vehicle-slider">-->
<!--          <div class="slick-slider VehicleSlider_vehicleSlider__f1Hi3 slick-initialized" dir="ltr">-->
<!--            <div class="slick-list">-->
<!--              <div class="slick-track slider1">-->
<!--                <div v-for="(item,index) in vehicles" :key="index" class="slick-slide slick-cloned" @click="sliderClick(index)">-->
<!--                  <div class="VehicleSlider_vehicleSliderItem__SIbRI" style="width:100%;display:inline-block;">-->
<!--                    <picture class="responsive-image&#45;&#45;picture">-->
<!--                      <source :srcset="require('@/assets/yw/' + item.image.desktop)" media="(max-width: 1023px)">-->
<!--                      <img :src="require('@/assets/yw/' + item.image.desktop)" class="ResponsiveImage_responsiveImage__OVw0A " style="max-width:83%!important;" draggable="false">-->
<!--                    </picture>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <div class="star-content" style="margin-top:44px;">
      <div v-if="sliderIndex == 0" class="star-title-content">
        <h3>探索星光城</h3>
        <div class="en-text text-up">explore MOOC star</div>
      </div>
      <div class="star-big-content">
        <div class="big-title">{{starModeList[sliderIndex].title}}</div>
        <div class="big-sub-title">{{starModeList[sliderIndex].titledesc}}</div>
        <div v-for="(item1,index1) in starModeList[sliderIndex].starCityList" :key="index1" class="start-big-item">
          <div class="img-title">
            <span></span>
            <span>{{item1.name}}</span>
            <span></span>
          </div>
          <img class="big-middle-img" :src="require('@/assets/business/'+item1.image)">
          <div class="start-big-item-title">项目介绍</div>
          <div class="start-big-item-title-en">PROJECT INTRODUCTION</div>
          <div class="start-big-item-sub-title"> {{item1.desc}}</div>
          <div class="start-big-item-title contact-us">联系我们</div>
          <div class="start-big-item-title-en">CONTACT US</div>
          <div class="start-big-item-code">
            <div class="start-qr-code">
              <img :src="require('@/assets/business/'+item1.qrcode)">
              <div class="text">微信公众号</div>
            </div>
            <div class="start-address-content">
              <div class="address-name">{{item1.name}}</div>
              <div class="address-position">
                <img style="margin-right: 5px;" src="@/assets/business/address.png">
                {{item1.address}}
              </div>
              <div class="address-phone">
                <img style="margin-right: 5px;" src="@/assets/business/phone.png">
                {{item1.phone}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

<!--    <div class="star-content" style="margin-top: 70px;">-->
<!--      <div class="star-title-content">-->
<!--        <h3>招商合作</h3>-->
<!--        <div class="en-text text-up">ATTRACT INVESTMENT</div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="grid-content">-->
<!--      <div class="grid-bg">-->
<!--        <div v-for="(item,index) in zsList" :key="index" class="grid-item">-->
<!--          <img src="">-->
<!--          <div class="grid-item-address">-->
<!--              <div>{{item.name}}</div>-->
<!--              <div>-->
<!--                {{item.address}}-->
<!--              </div>-->
<!--              <div>-->
<!--                {{item.phone}}-->
<!--              </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="star-content" style="margin-top: 100px;">-->
<!--      <div class="star-title-content">-->
<!--        <h3>合作品牌</h3>-->
<!--        <div class="en-text text-up">COOPERATIVE BRANDS</div>-->
<!--      </div>-->
<!--    </div>-->
<!--    <div class="community-content">-->
<!--        <div class="community-bg">-->
<!--          <div v-for="(item,index) in 48" :key="index" class="community-item">-->

<!--          </div>-->
<!--        </div>-->
<!--    </div>-->
  </div>
</template>


<script>
import topNav from '@/components/base/top-nav'
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import $ from 'jquery';
import 'slick-carousel';
export default {
  name: "busdetail",
  components:{
    topNav
  },
  data() {
    return {
      sliderIndex: 0,
      starModeList:[
        {
          title:'星光城——全包容型生活策源地',
          titledesc:'嘉宏集团旗下持有型的商业项目品牌，总商业体量近百万方，统一业态规划，统一运营管理。以城市综合体的全面资源打造精彩丰富的中高速生活方式。',
          starCityList:[
            {
              name:'孟河星光城',
              image:'a1.png',
              desc:'孟河星光城地处齐梁故里、汽配名地——孟河镇。该镇与紧邻的丹阳北、扬中南以及西夏墅、春江等地形成“大孟河区域”。作为孟河首座一站式全业态商业体，孟河星光城占据孟河门户、罗盘轴心，堪称“强镇之眼”！十大地标性业态环聚孟城强劲消费力，首进\n' +
                      '            孟河的国际国内知名品牌占比超过90%，更有500强企业温德姆酒店集团“温德姆”品牌首进常州，成为孟河镇首家五星级酒店！项目\n' +
                      '            辐射范围可达周边15公里。',
              qrcode:'a1_code.png',
              address:'江苏省常州市新北区孟河镇孟河大道转盘中心西南侧',
              phone:'0519-88110090'
            },
            {
              name:'奔牛星光城',
              image:'a2.png',
              desc:'       奔牛星光城位于教育重地——奔牛镇。该镇教育引擎全速推进，坐拥小学到高中各个层次的名校资源，区域消费实力愈发强劲。\n' +
                      '作为奔牛第一商业航母，奔牛星光城汇集购物中心、高端酒店、烫金商街、都会奢宅四大业态，坐拥综合菜市、公交枢纽等服务配套，\n' +
                      '引入了奔牛首家国际影城、奔牛首家肯德基、当地最大生活超市，将给奔牛家庭带来全新消费体验。\n',
              qrcode:'a2_code.png',
              address:'江苏省常州市新北区奔牛镇南观路和兴奔路交叉口西北侧',
              phone:'0519-85800028'
            },
            {
              name:'空港星光城',
              image:'a3.png',
              desc:'       空港国际星光城紧靠常州机场、位于空港强镇——罗溪镇。罗溪镇经济实力位列新北区第三位，上榜全国千强镇，是常州空港产\n' +
                      '业发展的主体，形成了智能装备制造、通用航空产业、现代物流三大产业板块。空港国际星光城以速度和服务驾乘港城经济，与孟河\n' +
                      '星光城、奔牛星光城合力，以企业的综合实力打造罗溪镇封面作品。\n',
              qrcode:'a3_code.png',
              address:'江苏省常州市新北区黄河西路与通达路交汇处',
              phone:'0519-85800028'
            },
            {
              name:'蔚蓝星光城',
              image:'a4.png',
              desc:'       蔚蓝星光城位于常州东部产业新区——经开区。该区是全市体制机制创新先行区、高新技术产业集聚区、生态文明示范区、产\n' +
                      '城融合样板区。蔚蓝星光城由蔚蓝天地社区、五星级酒店及商业MALL组合而立。作为布局龙城东部的一钻，嘉宏聚力投入，打造\n' +
                      '儿童乐园基地、健康运动社交场及家庭式消费共享空间，成就东大门璀璨之“星”，光耀城东！\n',
              qrcode:'a4_code.png',
              address:'江苏省常州市武进经开区龙城大道与曙兴路交叉口东南侧',
              phone:'0519-85800028'
            }
          ],
        },
        {
          title:'星光天地——都会级时尚社交平台',
          titledesc:'创新业态MALL，追求新奇与多元,优选精品与健康。面向市区级高品质青年客群，服务辅射人口15万。',
          starCityList:[
            {
              name:'星光天地',
              image:'b1.png',
              desc:'       星光天地坐落于常州市中心，紧靠常州人文胜地青果巷，毗邻历史重要商道古运河，这块风水宝地集聚了龙城历史风貌的精华。如\n' +
                      '今项目周边地铁通达，奢宅林立，是城市层峰人士的生活聚集地。作为嘉宏首个面世的商业综合体，星光天地颠覆了原金鹰百货模式，\n' +
                      '以“创新、萌宠、亲子”为核心业态，致力于为消费者提供“星宠趣未来”的城市生活新主张，被常州广播电视台授予2019“常州创新\n' +
                      '商业城市综合体奖”。',
              qrcode:'b1_code.png',
              address:'江苏省常州市钟楼区晋陵路与吊桥路交叉口西南侧',
              phone:'0519-89190020'
            }
          ],
        },
        {
          title:'星光里——邻里生活方式体验中心',
          titledesc:'       社区型商业，面向周边1公里的中高端居民，定位为便利、生活、时尚的配套生活MALL。',
          starCityList:[
            {
              name:'诺诚星光里',
              image:'c1.png',
              desc:'       诺诚高第星光里以嘉宏大型楼盘“嘉宏诺诚高第”为中心，定位于邻里中心生活配套MALL，着眼于便利、精品、优选，现已运\n' +
                      '营中，主力品牌包括：肯德基汽车穿梭餐厅（当时常州第一家、江苏第4家）、中国移动、中国联通、银行等配套业态全部到位，知\n' +
                      '名连锁餐饮及其他娱乐类业态品牌也相继进场，药房、便利店等社区配套均已完善。',
              qrcode:'c1_code.png',
              address:'江苏省常州市天宁区中吴大道与丽华北路交叉口西北侧',
              phone:'0519-85800028'
            },
            {
              name:'云顶星光里',
              image:'c2.png',
              desc:'       云顶星光里以嘉宏品质楼盘“嘉宏云顶”为中心，定位于邻里中心生活配套Mall，面向周边1公里的中高端居民，现已运营中，\n' +
                      '主力品牌有星范医美、金仕堡健身、品牌超市等。',
              qrcode:'c1_code.png',
              address:'江苏省常州市钟楼区怀德路与德清路交叉口西南侧',
              phone:'0519-85800028'
            }
          ],
        },
        {
          title:'嘉宏灯贸中心—华东区规模最大灯饰商场',
          titledesc:'',
          starCityList:[
            {
              name:'嘉宏灯贸中心',
              image:'d1.png',
              desc:'       华东区规模最大灯饰商场。服务辐射华东区域，联手数百家国内外知名灯具品牌，打造“高端一站式灯具体验中心”，为广大\n' +
                      '客户提供灯具体验、展示、设计等全方位服务。\n' +
                      '       灯贸中心位于邹区灯具城门户位置，是嘉宏集团斥巨资打造的中高端室内外照明灯饰商场，分为B、C两区，B区将打造为邹区\n' +
                      '独有品牌最多的专业高端灯具标杆市场，C区将作为华东地区最具规模的户外灯具和酒店用品市场。作为邹区灯具市场的行业标杆\n' +
                      '项目，灯贸中心引进了200多家国内外知名灯具品牌，是华东地区规模宏大、品类齐全、定位高端的一站式灯具体验中心，为广大\n' +
                      '客户提供灯具全方位体验、设计、展示等多种功能服务。',
              qrcode:'d1_code.png',
              address:'江苏省常州市钟楼区邹区镇东方大道与312国道交叉口西南侧',
              phone:'0519-83389888'
            }
          ],
        },
      ],
      zsList:[
        {
          image:'',
          name:'星光天地',
          address:'江苏省常州市钟楼区晋陵路与吊桥路交叉口西南侧',
          phone:'0519-89190020',
        },
        {
          image:'',
          name:'孟河星光城',
          address:'江苏省常州市新北区孟河镇孟河大道转盘中心西南侧',
          phone:'0519-88110090',
        },
        {
          image:'',
          name:'奔牛星光城',
          address:'江苏省常州市新北区奔牛镇南观路和兴奔路交叉口西北侧',
          phone:'0519-85800028',
        },
        {
          image:'',
          name:'蔚蓝星光城',
          address:'江苏省常州市武进经开区龙城大道与曙兴路交叉口东南侧',
          phone:'0519-85800028',
        },
        {
          image:'',
          name:'空港星光城',
          address:'江苏省常州市新北区黄河西路与通达路交汇处',
          phone:'0519-85800028',
        },
        {
          image:'',
          name:'嘉宏灯贸中心',
          address:'江苏省常州市钟楼区邹区镇东方大道与312国道交叉口西南侧',
          phone:'0519-83389888',
        },
        {
          image:'',
          name:'诺诚高第星光里',
          address:'江苏省常州市天宁区中吴大道与丽华北路交叉口西北侧',
          phone:'0519-85800028',
        },
        {
          image:'',
          name:'云顶星光里',
          address:'江苏省常州市钟楼区怀德路与德清路交叉口西南侧',
          phone:'0519-85800028',
        }
      ],
      vehicles: [
        {
          "image": {
            "desktop": "1.png",
            "mobile": "1.png"
          }
        },
        {
          "image": {
            "desktop": "2.png",
            "mobile": "2.png"
          }
        },
        {
          "image": {
            "desktop": "3.png",
            "mobile": "3.png"
          }
        },
        {
          "image": {
            "desktop": "4.png",
            "mobile": "4.png"
          }
        }
      ],
    }
  },
  mounted() {
    this.sliderIndex = this.$route.query.sliderIndex
  },
  methods: {

  }
}
</script>

<style>
  @import "../../styles/business.css";
</style>
